// extracted by mini-css-extract-plugin
module.exports = {"chapter":"chapter-cell_chapter__14lJ2"};